import { Loading } from '@components/atomic/atoms';
import { getProjectAggregateBusinessIntelligenceData } from '@lib/api_ts/aggregatesApi';
import { WithPermission } from '@lib/helpers/WithPermission';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

interface AggregateBusinessIntelligenceProps {}

const AggregateBusinessIntelligencePage: React.FC<AggregateBusinessIntelligenceProps> = () => {
	const { aggregateId } = useParams<{ aggregateId: string }>();

	const { data, isPending, isError } = useQuery({
		queryKey: ['businessIntelligenceData', aggregateId],
		queryFn: () => {
			return getProjectAggregateBusinessIntelligenceData(aggregateId);
		},
	});

	if (isPending) {
		return <Loading />;
	}

	if (isError) {
		return <div>Errore nel caricamento dei dati di Business Intelligence.</div>;
	}

	return (
		<div id="business-intelligence">
			<div className="container-fluid p-0">
				<Row className="justify-content-center">
					<WithPermission permission="view_bi_dashboard" mode="all">
						<iframe
							src={data.embedUrl}
							title="Business Intelligence"
							style={{
								width: '100vw',
								height: '80vh',
								border: 'none',
								display: 'block',
								maxWidth: '100%',
								padding: 0,
							}}
							allowFullScreen
						/>
					</WithPermission>
				</Row>
			</div>
		</div>
	);
};

export default AggregateBusinessIntelligencePage;
